const organization = {
    require_membership: 'O usuário deve ser um membro da organização para continuar.',
};
export default Object.freeze(organization);
